<template>
  <div class="flex flex-wrap">
    <div class="w-full md:w-1/2 my-8 md:pr-10">
      <div>
        <h2 class="leading-tight lg:leading-normal mb-6 text-4xl">Join the Community</h2>

        <div class="font-sans-book text-n-gray-dark text-lg leading-normal pr-10">
          <p class="mb-8">
            First visit to the Portal? Register here. If you already have an account, enter your login credentials on the right.
          </p>
        </div>

        <router-link :to="{ name: 'register' }" class="button">
          CREATE MY ACCOUNT
        </router-link>
      </div>
    </div>

    <div class="w-full md:w-1/2 my-8 md:pl-10">
      <div>
        <h2 class="mb-6 text-4xl">Login</h2>
        <form method="POST">
          <div class="mb-4">
            <label for="email" ref="email">
              Email
            </label>
            <input id="email" type="email" name="email" v-validate="'required|email'" v-model="form.email">
            <span v-show="errors.has('email')" class="error text-error-red text-lg">
              {{ errors.first('email') }}
            </span>
          </div>

          <div class="mb-4">
            <label for="password" ref="password">
              Password
            </label>
            <input
              id="password"
              :type="input.showPassword ? 'text' : 'password'"
              name="password"
              v-validate="'required|min:8'"
              v-model="form.password"
            />
            <button class="password-show-hide" type="button" @click="input.showPassword = !input.showPassword">
              <eye :off="input.showPassword" />
            </button>
            <span v-show="errors.has('password')" class="error text-error-red text-lg">
              {{ errors.first('password') }}
            </span>
          </div>

          <div class="flex flex-col">
            <div class="mr-6 mt-6 mb-6">
              <button class="button" @click.stop.prevent="login">
                Login
              </button>
            </div>
            <div class="">
              <router-link to="/auth/forgot" class="text-black">
                Forgot your password?
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import validation from "../../mixins/validation";
import Eye from "../images/icons/Eye.vue";
import {analyticsDataLayer} from "../../api/analyticsDataLayer";

export default {
  name: "UserLogin",
  components: {Eye},
  title: "User Login",
  mixins: [validation],
  data() {
    return {
      form: {
        email: null,
        password: null
      },
      input: {
        showPassword: false
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      isLoggedIn: "isLoggedIn",
    }),
  },
  watch: {
    $route: "logout",
  },
  methods: {
    validateLogin() {
      this.$validator.validate().then((result) => {
        if (!result) {
          return;
        }
        this.login();
      });
    },

    login() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.gotoFirstValidationError();
          return;
        }

        axios.get("/sanctum/csrf-cookie").then(() => {
          axios
            .post("/login", this.form)
            .then(() => {
              localStorage.setItem("isLoggedIn", "true");
              this.$store.dispatch("getMe").then(() => {
                analyticsDataLayer.emit('login', { method: 'email' });
                if (this.user.isAdmin) {
                  window.location.href = "/events";
                } else {
                  window.location.href = "/";
                }
              });
            })
            .catch(() => {
              const field = this.$validator.fields.find({
                name: "email",
                scope: this.$options.scope,
              });
              this.$validator.errors.add({
                id: field.id,
                field: "email",
                msg:
                  "Sorry, those credentials don't match our records",
                scope: this.$options.scope,
              });
            });
        });
      });
    },
    logout() {
      this.$toasted.clear();
      this.$store.dispatch("logoutUser");
    },
  },
  created() {
    this.logout();
  },
};
</script>

<style scoped>
  .password-show-hide {
    position: relative;
    float: right;
    width: 2.6em;
    margin-left:-2.6em;
    text-align:center;
    padding: 1rem 0 0.5rem;
    border: none;
    background:transparent;
    transition:transform 0.3s;
    transform-origin:center;
  }
  input[name=password] {
    padding-right: 2.6em;
  }
</style>
